import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SiteLayout } from "../components/site/SiteLayout";
import { SEO } from "../components/site/SEO";
import { useContent } from "../context/ContentContext";

export default function Services() {
  const { content } = useContent();
  const services = content.services || [];
  return (
    <SiteLayout>
      <SEO
        title="Services — Fourbees Consultancy | Doorstep Dairy, Marketing & Operations"
        description="Dairy business consultancy, route planning, social media management, website design, local advertising, MDS and administrative support, and transport & logistics consultancy."
        path="/services"
      />

      {/* Hero */}
      <section className="bg-cream py-24 md:py-32" data-testid="services-hero">
        <div className="container-site">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-8">
              <div className="section-number mb-3">Services</div>
              <h1 className="font-heading text-4xl sm:text-5xl lg:text-7xl font-extrabold text-navy leading-[1.0] tracking-[-0.025em]">
                Practical support, <br />
                <span className="text-gold">end to end.</span>
              </h1>
            </div>
            <div className="lg:col-span-4">
              <p className="font-body text-base md:text-lg text-charcoal/75 leading-relaxed">
                Pick a single service or combine several. We adapt how we work to how your business
                is set up — not the other way round.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services, editorial */}
      <section className="bg-cream border-t border-light-grey" data-testid="services-list">
        <div className="container-site">
          {services.map((s, i) => (
            <article
              key={s.slug}
              id={s.slug}
              className={`grid grid-cols-1 lg:grid-cols-12 gap-10 py-20 ${
                i < services.length - 1 ? "border-b border-light-grey" : ""
              }`}
              data-testid={`service-${s.slug}`}
            >
              <div className="lg:col-span-4">
                <div className="section-number mb-3">{s.index} — Service</div>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy leading-tight tracking-tight">
                  {s.title}
                </h2>
              </div>
              <div className="lg:col-span-6 space-y-4 font-body text-base md:text-lg text-charcoal/80 leading-relaxed">
                {(typeof s.long === "string" ? s.long.split(/\n\n+/) : s.long || []).map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}
              </div>
              <div className="lg:col-span-2 lg:text-right">
                <Link
                  to={`/contact?service=${encodeURIComponent(s.title)}`}
                  className="btn-primary w-full lg:w-auto"
                  data-testid={`service-cta-${s.slug}`}
                >
                  Enquire
                  <ArrowRight size={14} strokeWidth={2.5} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Footer-ish closer */}
      <section className="bg-navy text-cream py-20" data-testid="services-closer">
        <div className="container-site text-center max-w-3xl mx-auto">
          <div className="section-number mb-3">— Not sure where to start?</div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-cream leading-tight tracking-tight mb-5">
            Have a conversation first. Decide later.
          </h2>
          <p className="font-body text-cream/70 leading-relaxed mb-8">
            Most of our work starts with a straightforward call — understanding what you're
            working on and whether we're the right fit. No commitment, no pressure.
          </p>
          <Link to="/contact" className="btn-gold" data-testid="services-closer-cta">
            Start a Conversation
            <ArrowRight size={16} strokeWidth={2.5} />
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}
